module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAAXNSR0IArs4c6QAAAOZJREFUSEtjLCgo+M9AY8AIsmTChAmMtLIHZP6oJUSHLkXB5eDAwAKy6cABhj/4bCTbEpAFStxmy0GG3/t6KhKfRWRZArOAkZEx5P///y/+/f1luWDHhQe4fEOyJRgW/P7ruGDX2RtUCy5yLABZTrRPyLWAaEsosYBoS5J8zKYzMjBmMPwHJdW/hnO3nrlCdCYhNrgS3Iw1mFiZ9zMyMkr8//9/DaEki+4AouOEEouItgTkOnItIskSci0i2RJyLCLLEmSLQGyqFyvIKQcURyA+VYsVUvIGslqyg4sUC4ehJaR4nxy1AAJCJuBZrixXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/pageleft.png
// module id = aoVN
// module chunks = 1